import { defineMessages } from 'react-intl';

/** The copy of the Profile page (design artist-profile a1–a3, d). */
export const profileMessages = defineMessages({
  crumb: { id: 'app.sml.promote.profile.crumb', defaultMessage: 'Profile' },
  title: { id: 'app.sml.promote.profile.title', defaultMessage: 'Your profile' },
  subtitle: {
    id: 'app.sml.promote.profile.subtitle',
    defaultMessage:
      'One look on every page where fans find you. Make your Spotify header and photo, your banners, press photos and bio here, then put them up.',
  },
  useRelease: { id: 'app.sml.promote.profile.useRelease', defaultMessage: 'Use a release' },
  downloadAll: { id: 'app.sml.promote.profile.downloadAll', defaultMessage: 'Download all' },
  downloadAllBusy: { id: 'app.sml.promote.profile.downloadAll.busy', defaultMessage: 'Making the zip…' },
  freeTitle: {
    id: 'app.sml.promote.profile.free.title',
    defaultMessage: 'Free makes half-size previews with the MUSIC24 mark.',
  },
  freeBody: {
    id: 'app.sml.promote.profile.free.body',
    defaultMessage:
      'Upgrade to get full-size files with no mark, and to send them to Spotify. Profile images cost no credits.',
  },
  freeTitleNarrow: { id: 'app.sml.promote.profile.free.titleNarrow', defaultMessage: 'Free makes marked previews.' },
  freeBodyNarrow: {
    id: 'app.sml.promote.profile.free.bodyNarrow',
    defaultMessage: 'Upgrade for full-size clean files and Spotify upload.',
  },
  upgrade: { id: 'app.sml.promote.profile.upgrade', defaultMessage: 'Upgrade' },
  askOwner: { id: 'app.sml.promote.profile.askOwner', defaultMessage: 'Ask the owner to upgrade' },
  lookLabel: { id: 'app.sml.promote.profile.look.label', defaultMessage: 'Your artist look' },
  lookLabelNarrow: { id: 'app.sml.promote.profile.look.labelNarrow', defaultMessage: 'Look' },
  lookSavedFrom: {
    id: 'app.sml.promote.profile.look.savedFrom',
    defaultMessage:
      'Saved from {title}. New profile images use it. A picture from a release can use the look of that release.',
  },
  lookNoRelease: {
    id: 'app.sml.promote.profile.look.noRelease',
    defaultMessage: 'New profile images use it. A picture from a release can use the look of that release.',
  },
  lookChange: { id: 'app.sml.promote.profile.look.change', defaultMessage: 'Change' },
  emptyTitle: { id: 'app.sml.promote.profile.empty.title', defaultMessage: 'Make your profile set from {title}' },
  emptyBody: {
    id: 'app.sml.promote.profile.empty.body',
    defaultMessage:
      'The Spotify header, the YouTube and Facebook banners from the cover and the colours of your newest release. Free, about 20 seconds. You can change each one after.',
  },
  emptyMake: { id: 'app.sml.promote.profile.empty.make', defaultMessage: 'Make my profile set' },
  emptyMakeNarrow: { id: 'app.sml.promote.profile.empty.makeNarrow', defaultMessage: 'Make' },
  emptyPickAnother: { id: 'app.sml.promote.profile.empty.pickAnother', defaultMessage: 'Pick another release' },
  emptyNoSongTitle: { id: 'app.sml.promote.profile.empty.noSong.title', defaultMessage: 'Add a song first' },
  emptyNoSongBody: {
    id: 'app.sml.promote.profile.empty.noSong.body',
    defaultMessage: 'Your profile set comes from the cover and the colours of a release. Add a song with its cover.',
  },
  emptyAddSong: { id: 'app.sml.promote.profile.empty.addSong', defaultMessage: 'Add song' },
  making: {
    id: 'app.sml.promote.profile.making',
    defaultMessage: 'About 10 seconds. The current file stays until the new one is ready.',
  },
  failed: {
    id: 'app.sml.promote.profile.failed',
    defaultMessage: 'We could not make the {name}. It was free, so no credits were used.',
  },
  failedSourceGone: {
    id: 'app.sml.promote.profile.failed.sourceGone',
    defaultMessage: 'The picture you picked for the {name} is gone. Pick another picture and make it again.',
  },
  tryAgain: { id: 'app.sml.promote.profile.tryAgain', defaultMessage: 'Try again' },
  download: { id: 'app.sml.promote.profile.download', defaultMessage: 'Download' },
  edit: { id: 'app.sml.promote.profile.edit', defaultMessage: 'Edit' },
  makeIt: { id: 'app.sml.promote.profile.makeIt', defaultMessage: 'Make it' },
  makeThem: { id: 'app.sml.promote.profile.makeThem', defaultMessage: 'Make them' },
  iSetIt: { id: 'app.sml.promote.profile.iSetIt', defaultMessage: 'I set it' },
  notSet: { id: 'app.sml.promote.profile.notSet', defaultMessage: 'Not set yet' },
  more: { id: 'app.sml.promote.profile.more', defaultMessage: 'More' },
  free: { id: 'app.sml.promote.profile.free', defaultMessage: 'Free' },
  spotifyName: { id: 'app.sml.promote.profile.card.spotify', defaultMessage: 'Spotify' },
  spotifySize: {
    id: 'app.sml.promote.profile.card.spotify.size',
    defaultMessage: 'Header 2660 x 1140 · Photo 1500 x 1500',
  },
  spotifySizeNarrow: { id: 'app.sml.promote.profile.card.spotify.sizeNarrow', defaultMessage: 'Header · photo' },
  spotifyPreviewSize: {
    id: 'app.sml.promote.profile.card.spotify.previewSize',
    defaultMessage: 'Preview {width} x {height}',
  },
  artistPhoto: { id: 'app.sml.promote.profile.card.artistPhoto', defaultMessage: 'Artist photo' },
  editHeader: { id: 'app.sml.promote.profile.card.editHeader', defaultMessage: 'Edit header' },
  editPhoto: { id: 'app.sml.promote.profile.card.editPhoto', defaultMessage: 'Edit photo' },
  uploadToSpotify: { id: 'app.sml.promote.profile.uploadToSpotify', defaultMessage: 'Upload to Spotify' },
  uploadShort: { id: 'app.sml.promote.profile.uploadShort', defaultMessage: 'Upload' },
  putItUpYourself: { id: 'app.sml.promote.profile.putItUpYourself', defaultMessage: 'How to put it up' },
  upgradeToSend: { id: 'app.sml.promote.profile.upgradeToSend', defaultMessage: 'Upgrade to send to Spotify' },
  spotifyOnSince: {
    id: 'app.sml.promote.profile.card.spotify.onSince',
    defaultMessage: 'On Spotify since {date} · version {version}',
  },
  spotifyPhotoFromSettings: {
    id: 'app.sml.promote.profile.card.spotify.photoFromSettings',
    defaultMessage: 'The photo is your profile photo from Settings → Artist',
  },
  youtubeName: { id: 'app.sml.promote.profile.card.youtube', defaultMessage: 'YouTube banner' },
  youtubeSize: {
    id: 'app.sml.promote.profile.card.youtube.size',
    defaultMessage: '2560 x 1440 · the middle 1546 x 423 shows everywhere',
  },
  facebookName: { id: 'app.sml.promote.profile.card.facebook', defaultMessage: 'Facebook cover' },
  facebookSize: { id: 'app.sml.promote.profile.card.facebook.size', defaultMessage: '851 x 315' },
  pressName: { id: 'app.sml.promote.profile.card.press', defaultMessage: 'Press photos' },
  pressSize: { id: 'app.sml.promote.profile.card.press.size', defaultMessage: '3:2 · 4:5 · 1:1 from one photo' },
  pressMeta: {
    id: 'app.sml.promote.profile.card.press.meta',
    defaultMessage: 'For blogs, playlists and your press kit',
  },
  pressLandscape: { id: 'app.sml.promote.profile.card.press.landscape', defaultMessage: '3:2 · 3000 x 2000' },
  pressPortrait: { id: 'app.sml.promote.profile.card.press.portrait', defaultMessage: '4:5 · 2400 x 3000' },
  pressSquare: { id: 'app.sml.promote.profile.card.press.square', defaultMessage: '1:1 · 3000' },
  bannersName: { id: 'app.sml.promote.profile.card.banners', defaultMessage: 'Banners' },
  bannersSize: { id: 'app.sml.promote.profile.card.banners.size', defaultMessage: 'YouTube, Facebook' },
  bioName: { id: 'app.sml.promote.profile.card.bio', defaultMessage: 'Bio' },
  bioSize: { id: 'app.sml.promote.profile.card.bio.size', defaultMessage: 'Short 160 · Long 1500 characters' },
  bioSizeNarrow: { id: 'app.sml.promote.profile.card.bio.sizeNarrow', defaultMessage: 'Short and long' },
  writeForMe: { id: 'app.sml.promote.profile.card.bio.writeForMe', defaultMessage: 'Write it for me' },
  copyShort: { id: 'app.sml.promote.profile.card.bio.copyShort', defaultMessage: 'Copy short' },
  copyLong: { id: 'app.sml.promote.profile.card.bio.copyLong', defaultMessage: 'Copy long' },
  copied: { id: 'app.sml.promote.profile.copied', defaultMessage: 'Copied' },
  bioMeta: {
    id: 'app.sml.promote.profile.card.bio.meta',
    defaultMessage: 'Spotify takes the bio in Spotify for Artists: copy it there.',
  },
  metaSource: { id: 'app.sml.promote.profile.card.meta.source', defaultMessage: '{source} · {title}' },
  chipNotMade: { id: 'app.sml.promote.profile.chip.notMade', defaultMessage: 'Not made' },
  chipMaking: { id: 'app.sml.promote.profile.chip.making', defaultMessage: 'Making' },
  chipFailed: { id: 'app.sml.promote.profile.chip.failed', defaultMessage: 'Failed' },
  chipReady: { id: 'app.sml.promote.profile.chip.ready', defaultMessage: 'Ready' },
  chipPreview: { id: 'app.sml.promote.profile.chip.preview', defaultMessage: 'Preview' },
  chipOnSpotify: { id: 'app.sml.promote.profile.chip.onSpotify', defaultMessage: 'On Spotify' },
  chipSending: { id: 'app.sml.promote.profile.chip.sending', defaultMessage: 'Sending' },
  chipChangedOnSpotify: { id: 'app.sml.promote.profile.chip.changedOnSpotify', defaultMessage: 'Changed on Spotify' },
  chipUploadFailed: { id: 'app.sml.promote.profile.chip.uploadFailed', defaultMessage: 'Upload failed' },
  chipSetOnYoutube: { id: 'app.sml.promote.profile.chip.setOnYoutube', defaultMessage: 'Set on YouTube' },
  chipSetOnFacebook: { id: 'app.sml.promote.profile.chip.setOnFacebook', defaultMessage: 'Set on Facebook' },
  chipSaved: { id: 'app.sml.promote.profile.chip.saved', defaultMessage: 'Saved' },
  chipEmpty: { id: 'app.sml.promote.profile.chip.empty', defaultMessage: 'Empty' },
  pickerTitle: { id: 'app.sml.promote.profile.releasePicker.title', defaultMessage: 'Use a release' },
  pickerBody: {
    id: 'app.sml.promote.profile.releasePicker.body',
    defaultMessage:
      'Make your Spotify header and your YouTube and Facebook banners from the cover of a release, in its colours. Free. Your profile keeps the old versions.',
  },
  pickerEmpty: { id: 'app.sml.promote.profile.releasePicker.empty', defaultMessage: 'No release has a cover yet.' },
  pickerConfirm: { id: 'app.sml.promote.profile.releasePicker.confirm', defaultMessage: 'Use it' },
  pickerCancel: { id: 'app.sml.promote.profile.releasePicker.cancel', defaultMessage: 'Cancel' },
  releaseOut: { id: 'app.sml.promote.profile.release.out', defaultMessage: 'Out {date}' },
  releaseOutTheme: { id: 'app.sml.promote.profile.release.outTheme', defaultMessage: 'Out {date} · {theme}' },
  releaseNoDate: { id: 'app.sml.promote.profile.release.noDate', defaultMessage: 'No release day' },
});
